// extracted by mini-css-extract-plugin
module.exports = {"VideoPage":"_1eFskiFXg2IEB6jZ9jwI_l"};